import React, { useEffect } from "react";
import { FormControl, MenuItem, Select } from "@mui/material";
import { replaceBracketPlaceholders } from "../utilities/replaceBracketPlaceholder";

const ColumnTax = ({
  params,
  item,
  handleRowUpdate,
  colTaxOptions,
  formAction,
  documentSelectTableData,
}) => {
  useEffect(() => {
    const currentValue = params?.row?.[item?.sColumnID];

    const hasExistingValue =
      currentValue !== undefined &&
      currentValue !== null &&
      String(currentValue).trim() !== "";

    if (hasExistingValue) return;

    if (formAction === "EDIT" || documentSelectTableData?.length > 0) {
      return;
    }

    handleRowUpdate({
      fieldName: item?.sColumnID,
      value: item?.inputType?.component?.sDefaultValue,
      rowId: params?.row?.id,
    });
  }, []);

  const fieldId =
    params?.row?._fieldIds?.[item?.sColumnID] ||
    item?.inputType?.component?.sName;

  return (
    <FormControl
      {...item?.inputType?.component?.sProps}
      {...item?.inputType?.component?.options?.others1}
    >
      <Select
        id={`${fieldId}-${params?.row?.id}`}
        value={params?.row?.[item?.sColumnID] ?? ""}
        style={{ width: "130px" }}
        onChange={(e) =>
          handleRowUpdate({
            rowId: params?.row?.id,
            fieldName: item?.sColumnID,
            value: e?.target?.value,
          })
        }
        {...item?.inputType?.component?.sProps}
        {...item?.inputType?.component?.options?.others1}
      >
        {colTaxOptions?.map((taxItem, index) => (
          <MenuItem
            key={index}
            value={taxItem[item?.inputType?.data?.sValueField]}
          >
            <div
              component="span"
              style={{ width: "100%" }}
              dangerouslySetInnerHTML={{
                __html:
                  taxItem &&
                  taxItem !== "" &&
                  Object.keys(taxItem).length !== 0
                    ? replaceBracketPlaceholders(
                        item?.inputType?.data?.sDisplayFormat,
                        taxItem
                      )
                        ?.replace(/[{}]/g, "")
                        ?.split(",")
                    : "",
              }}
            />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ColumnTax;